import { sqliteTable, text, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// recurring_templates — รายการซ้ำ (Recurring Transactions)
// ============================================================================
export const recurringTemplates = sqliteTable("accounting_recurring_templates", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  name: text("name").notNull(), // e.g., "ค่าเช่าสำนักงาน"
  description: text("description"),
  frequency: text("frequency", {
    enum: ["monthly", "quarterly", "yearly"],
  }).notNull().default("monthly"),
  nextRunDate: text("next_run_date").notNull(), // YYYY-MM-DD
  lastRunDate: text("last_run_date"), // last time it was processed
  endDate: text("end_date"), // nullable — if null, runs forever
  templateType: text("template_type", {
    enum: ["journal_entry", "invoice"],
  }).notNull(),
  // Template data stored as JSON text
  templateData: text("template_data").notNull(), // JSON string of the template (items/lines)
  isActive: integer("is_active").notNull().default(1),
  autoPost: integer("auto_post").notNull().default(0), // 0=create draft, 1=auto submit
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  rt_company_active_idx: index("rt_company_active_idx").on(table.companyId, table.isActive),
  rt_next_run_idx: index("rt_next_run_idx").on(table.nextRunDate, table.isActive),
}));

// Type exports
export type RecurringTemplate = typeof recurringTemplates.$inferSelect;
export type NewRecurringTemplate = typeof recurringTemplates.$inferInsert;
